import { stylesheet } from 'typestyle'

export const FreeModeStyle = stylesheet({
  controls: {
    height: '44px'
  }
})
